// React Imports
import { ReactElement } from "react";

interface ViewEmailProps {
  onCancel: () => void;
}

const ViewEmailTemplate: React.FC<ViewEmailProps> = ({
  onCancel,
}: ViewEmailProps): ReactElement => {
  return (
    <div className=" flex flex-col w-full px-5">
      <h4 className="border-b-[1px] border-gray-900 mb-5 w-full pb-3 text-lg font-semibold">
        Pending Application: {"{"} ACCOUNT_NAME {"}"}
      </h4>
      <div className=" flex flex-col border-b-[1px] border-gray-900 mb-1 w-full pb-7">
        <p className=" text-base leading-relaxed">
          Dear WM Support unit, <br></br>A new applicant has submitted their
          onboarding documents which require an action to be taken from your
          side. Please, login to proceed with the action required
        </p>
        <p className=" mt-5 mb-3 text-lg font-medium">Variables:</p>
        <ul>
          <li className="">
            <span className="me-5">Name:</span>
            <span className=" text-blue-500">
              {" "}
              {"{"} ACCOUNT_NAME{"}"}
            </span>
          </li>
          <li className="mt-3">
            <span className="me-5">Account Type: </span>
            <span className=" text-blue-500">
              {" "}
              {"{"} ACCOUNT_TYPE{"}"}
            </span>
          </li>
          <li className="mt-3">
            <span className="me-5">Nationality: </span>
            <span className=" text-blue-500">
              {" "}
              {"{"} ACCOUNT_NATIONALITY{"}"}
            </span>
          </li>
          <li className="mt-3">
            <span className="me-5">Date Applied:</span>
            <span className=" text-blue-500">
              {" "}
              {"{"} ACCOUNT_CREATE_TIME{"}"}
            </span>
          </li>
          <li className="mt-3">
            <span className="me-5">Remark:</span>
            <span className=" text-blue-500">
              {" "}
              {"{"} ADMIN_NOTE{"}"}
            </span>
          </li>
        </ul>
      </div>
      <div className="flex items-center justify-end">
        <button
          onClick={onCancel}
          className=" w-full md:w-1/3 cursor-pointer rounded-xl border-[1px] border-blue-500 py-3 px-4 text-base bg-transparent text-blue-500 mt-5 font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ViewEmailTemplate;
